/**
 * The client a host constructs once and hands to the provider.
 *
 * Grouped by resource rather than flat, because the flat surface is 127 route decorators
 * and a skin needs maybe forty of them. What is covered here is the module's demonstrable
 * spine: items and their groups, UOM and conversion, warehouses/zones/bins, the stock
 * ledger and its balances, availability and reservations, counting, and replenishment.
 * Valuation, traceability, transfers and procurement have routes on the server and no
 * client here yet; adding one is a new file in `api/` and a line below.
 */
import { InventoryTransport } from '../http/transport.js';
import { BarcodesApi, ItemGroupsApi, ItemsApi } from './items.js';
import { LocationsApi } from './locations.js';
import { OrganizationsApi } from './organizations.js';
import { CountingApi, ReplenishmentApi, ReservationsApi } from './planning.js';
import { StockApi } from './stock.js';
import { UomApi } from './uom.js';
export class InventoryClient {
    transport;
    organizations;
    items;
    itemGroups;
    barcodes;
    uoms;
    locations;
    stock;
    reservations;
    counting;
    replenishment;
    constructor(config) {
        this.transport = new InventoryTransport(config);
        this.organizations = new OrganizationsApi(this.transport);
        this.items = new ItemsApi(this.transport);
        this.itemGroups = new ItemGroupsApi(this.transport);
        this.barcodes = new BarcodesApi(this.transport);
        this.uoms = new UomApi(this.transport);
        this.locations = new LocationsApi(this.transport);
        this.stock = new StockApi(this.transport);
        this.reservations = new ReservationsApi(this.transport);
        this.counting = new CountingApi(this.transport);
        this.replenishment = new ReplenishmentApi(this.transport);
    }
}
export function createInventoryClient(config) {
    return new InventoryClient(config);
}
//# sourceMappingURL=client.js.map